import { BugAntIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/state/auth';

export interface SummonConstantineButtonProps {
  /** Handler for button click */
  onClick: () => void;
  /** Disable the button (default: false) */
  disabled?: boolean;
  /** Test ID for E2E testing */
  'data-testid'?: string;
}

export function SummonConstantineButton({
  onClick,
  disabled = false,
  'data-testid': testId = 'summon-constantine-button',
}: SummonConstantineButtonProps) {
  const { isPraetorianUser } = useAuth();

  if (!isPraetorianUser) return null;

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className="rounded-full"
      size="sm"
      data-testid={testId}
      aria-label="Summon Constantine"
    >
      <BugAntIcon className="size-4" />
      Summon Constantine
    </Button>
  );
}
